'use strict';

module.exports = require('./index').default;


//////////////////
// WEBPACK FOOTER
// ./~/requestanimationframe-timer/dist/cjs.js
// module id = 261
// module chunks = 0